module.exports = __webpack_public_path__ + "static/media/nao-encontramos-a-pagina-anage.cbaefbff.svg";